import { TApplicationState } from '../../types/redux';

export const isConsultantChatOpenedSelector = (state: TApplicationState) => state.consultantCianChat.isOpened;
